import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import TeamSection from "@/components/TeamSection";
import SEO from "@/components/SEO";

const Team = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Meet The Team | Neil AI Global Solutions"
        description="Meet the executive leadership, sales, and technology team behind Neil AI Global Solutions — North Carolina's premier AI automation and PUDU robotics partner."
        keywords="Neil AI team, Albert Saunders, AI leadership North Carolina, PUDU robotics dealer team"
      />
      <Navigation />
      <main className="pt-32 md:pt-40">
        <TeamSection />
      </main>
      <Footer />
    </div>
  );
};

export default Team;
